// DO NOT EDIT -- generated from fs/services/search-settings/segments.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace Segments {

  export const ArchiveSegmentEndpoint = "/grpc/search_settings.Segments/ArchiveSegment";
  /**
   * Archive an existing segment for an org.
   * Once archived, the segment cannot be modified and will not show up in GetAllSegments unless explicitly requested.
   */
  export function ArchiveSegment(sender: (req: ArchiveSegmentRequest, endpoint: string) => Promise<ArchiveSegmentResponse>, req: ArchiveSegmentRequest): { promise: () => Promise<ArchiveSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveSegmentEndpoint),
      endpoint: ArchiveSegmentEndpoint
    };
  }

  export const UnarchiveSegmentEndpoint = "/grpc/search_settings.Segments/UnarchiveSegment";
  /**
   * Unarchives an existing segment for an org.
   * Once unarchived, the segment can continue to be modified and will show up in GetAllSegments.
   */
  export function UnarchiveSegment(sender: (req: UnarchiveSegmentRequest, endpoint: string) => Promise<UnarchiveSegmentResponse>, req: UnarchiveSegmentRequest): { promise: () => Promise<UnarchiveSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveSegmentEndpoint),
      endpoint: UnarchiveSegmentEndpoint
    };
  }

  export const GetAllSegmentsEndpoint = "/grpc/search_settings.Segments/GetAllSegments";
  /**
   * Get all current non-archived segments for an org.
   * If desired, archived segments can also be retrieved with the explicit request flag.
   */
  export function GetAllSegments(sender: (req: GetAllSegmentsRequest, endpoint: string) => Promise<GetAllSegmentsResponse>, req: GetAllSegmentsRequest): { promise: () => Promise<GetAllSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSegmentsEndpoint),
      endpoint: GetAllSegmentsEndpoint
    };
  }

  export const ListSegmentsEndpoint = "/grpc/search_settings.Segments/ListSegments";
  /**
   * Lists segments returning a batch of segments and pagination token.
   * A sane default limit per batch is enforced if no limit is provided.
   * The listed results can be filtered per the request.
   * The results are in descending created order.
   */
  export function ListSegments(sender: (req: ListSegmentsRequest, endpoint: string) => Promise<ListSegmentsResponse>, req: ListSegmentsRequest): { promise: () => Promise<ListSegmentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSegmentsEndpoint),
      endpoint: ListSegmentsEndpoint
    };
  }

  export const GetSegmentEndpoint = "/grpc/search_settings.Segments/GetSegment";
  /** Get a specific segment, either current or past version. */
  export function GetSegment(sender: (req: GetSegmentRequest, endpoint: string) => Promise<GetSegmentResponse>, req: GetSegmentRequest): { promise: () => Promise<GetSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentEndpoint),
      endpoint: GetSegmentEndpoint
    };
  }

  export const BatchGetSegmentsEndpoint = "/grpc/search_settings.Segments/BatchGetSegments";
  /** Get a specific set of segments, either current or past versions. */
  export function BatchGetSegments(sender: (req: BatchGetSegmentRequest, endpoint: string) => Promise<BatchGetSegmentResponse>, req: BatchGetSegmentRequest): { promise: () => Promise<BatchGetSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSegmentsEndpoint),
      endpoint: BatchGetSegmentsEndpoint
    };
  }

  export const SetSegmentEndpoint = "/grpc/search_settings.Segments/SetSegment";
  /** Add a new segment or update an existing segment. */
  export function SetSegment(sender: (req: SetSegmentRequest, endpoint: string) => Promise<SetSegmentResponse>, req: SetSegmentRequest): { promise: () => Promise<SetSegmentResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSegmentEndpoint),
      endpoint: SetSegmentEndpoint
    };
  }

  export const GetSegmentsAccessEndpoint = "/grpc/search_settings.Segments/GetSegmentsAccess";
  export function GetSegmentsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentsAccessEndpoint),
      endpoint: GetSegmentsAccessEndpoint
    };
  }
}

export namespace SegmentsPublic {

  export const GetSegmentsAccessEndpoint = "/grpc/search_settings.SegmentsPublic/GetSegmentsAccess";
  export function GetSegmentsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentsAccessEndpoint),
      endpoint: GetSegmentsAccessEndpoint
    };
  }
}

export enum Constants {
  INVALID = 0,
  /** default ListSegments limit when none is provided */
  DEFAULT_LIST_SEGMENTS_LIMIT = 20,
  /** max ListSegments limit when a higher limit is provided */
  MAX_LIST_SEGMENTS_LIMIT = 100
}

export interface Segment {
  id: string;
  name: string;
  description: string;
  segmentDefinition: segment.SegmentDefinition | null;
}

export interface SegmentMetadata {
  /**
   * When true, indicates the segment is canned.
   * Canned segments are not stored, cannot be updated, and do not have audit metadata.
   */
  canned: boolean;
}

export interface SegmentRecord {
  segment: Segment | null;
  segmentMetadata: SegmentMetadata | null;
  metadata: protoauditstore.AuditMetadata | null;
}

export interface ArchiveSegmentRequest {
  orgId: string;
  segmentId: string;
}

export interface ArchiveSegmentResponse {
  segment: SegmentRecord | null;
}

export interface UnarchiveSegmentRequest {
  orgId: string;
  segmentId: string;
}

export interface UnarchiveSegmentResponse {
  segment: SegmentRecord | null;
}

export interface GetAllSegmentsRequest {
  orgId: string;
  /** If true, archived segments will also be returned. */
  includeArchived: boolean;
  /** By default, only public segments are returned */
  includePrivate: boolean;
}

export interface GetAllSegmentsResponse {
  segments: SegmentRecord[];
}

export interface ListSegmentsRequest {
  orgId: string;
  /** if non empty, picks back up where a previous list response ended */
  paginationToken: string;
  /** if non empty, filters results to just those for the provided creator */
  creator: string;
  /** if non empty, filters results to just those created in the given time range (inclusive start, exclusive end) */
  createdBetween: ListSegmentsRequest.ListTimeRange | null;
  /** if true, canned segments are excluded from the response */
  excludeCanned: boolean;
  /** if non empty, enforces a limit on the number of returned segments, defaults to 20 and maxes out at 100 */
  limit: number;
}

export namespace ListSegmentsRequest {
  export interface ListTimeRange {
    start: protobuf.timestamp | null;
    end: protobuf.timestamp | null;
  }
}

export interface ListSegmentsResponse {
  segments: SegmentRecord[];
  /** if non empty, there are more results */
  nextPaginationToken: string;
}

/** Solely used internally to encode a pagination token. */
export interface ListSegmentsPaginationToken {
  customCursor?: string;
  cannedCursor?: string;
}

/** Solely used internally to encode a pagination token. */
export namespace ListSegmentsPaginationToken {
  export enum type {
    customCursor = 4,
    cannedCursor = 2
  }

  export function type_oneof(m: ListSegmentsPaginationToken): { opt: type.cannedCursor, val: string } | { opt: type.customCursor, val: string } | null {
    if (m.customCursor != null) { return { opt: type.customCursor, val: m.customCursor } }
    if (m.cannedCursor != null) { return { opt: type.cannedCursor, val: m.cannedCursor } }
    return null;
  }
}

export interface GetSegmentRequest {
  /** required */
  orgId: string;
  /** required */
  segmentId: string;
  /** optional. If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetSegmentResponse {
  versions: SegmentRecord[];
}

export interface BatchGetSegmentRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetSegmentRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetSegmentRequest {
  export interface Identifier {
    /** required */
    segmentId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned. */
    version: protobuf.int64;
  }
}

export interface BatchGetSegmentResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found segments will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetSegmentResponse.Result[];
}

export namespace BatchGetSegmentResponse {
  export interface Result {
    identifier: BatchGetSegmentRequest.Identifier | null;
    versions: SegmentRecord[];
  }
}

export interface SetSegmentRequest {
  orgId: string;
  /**
   * Segment to be created or updated.
   * If the id field is not set, an id will be generated and a segment will be stored.
   * If an id field is set, an existing segment must be in place to perform the update.
   */
  segment: Segment | null;
  /**
   * If set, dedupes create requests containing the same idempotence key.
   * If idempotence key has already been handled, the existing entity will be returned instead of creating a new entity.
   * The idempotence key is only respected on create requests that let the server generate the entity id.
   * Note: This is best effort. Idempotence keys are kept around for three days but may be garbage collected sooner.
   * string idempotence_key = 3; TODO(clay): add support once migrated to native store
   */
  visibility: protoauditstore.Visibility;
}

export interface SetSegmentResponse {
  segment: SegmentRecord | null;
}

export interface MigrateSegmentsRequest {
  /** if supplied, migrates the selected orgs, otherwise, migrates all orgs */
  orgIds: string[];
}

export interface MigrateSegmentsResponse {
  /** number of orgs migrated in this pass */
  numOrgsMigrated: number;
}
